import { useState, useEffect } from 'react';
import { instance } from '../../common';

const ServiceList = (props) => {
  const [serviceInfo, setServiceInfo] = useState([
    {
      category: '',
      service_name: '',
      date: '',
      price: '',
    },
  ]);
  const [shopInfo, setShopInfo] = useState({
    shop_name: '',
    contact: '',
  });
  const [totalPrice, setTotalPrice] = useState(0);
  const [discount, setDiscount] = useState(0);

  useEffect(async () => {
    try {
      const rawData = await instance.post('/reserve/r_id', {
        r_id: props.r_id,
      });
      const data = rawData.data[0];
      // console.log('service info data is: ', data);

      const endDate = data.r_enddate;
      const shopData = JSON.parse(data.s_id);
      let total = 0;
      // console.log('shop data is: ', shopData);
      setServiceInfo(() => {
        return shopData.map((obj) => {
          // console.log('obj is: ', obj);
          let price = obj.s_member_price;
          // if (obj.s_cate !== '썬가드하이퍼이벤트') price = obj.s_member_price;

          total += price * 1; // **

          return {
            category: obj.s_cate,
            service_name: obj.s_name,
            date: endDate,
            price,
          };
        });
      });
      setTotalPrice(total);

      const rawSigong = await instance.post('/sigong/id', {
        si_id: data.si_id,
      });
      const sigong = rawSigong.data[0];
      setShopInfo({
        shop_name: sigong.si_name,
        contact: sigong.si_tel,
      });

      const rawContract = await instance.post('/contract/number', {
        co_number: data.contract_num,
        u_type: '시공지점',
      });
      const contract = rawContract.data.rows[0];
      setDiscount(contract.co_discount * 1);
    } catch (error) {
      console.log(error);
    }
  }, []);

  // console.log('what is service info: ', serviceInfo);
  return (
    <section>
      <h4 className="col-12 p-0 mt-5 mb-3 font-weight-bold chRyangTitle">
        서비스 목록
      </h4>
      <table className="table table-bordered bojungTable mb-0">
        {serviceInfo.map((v, i) => (
          <tbody key={i}>
            <tr>
              <th
                colSpan="5"
                className="sTdBgblue"
                style={{ verticalAlign: 'middle' }}
              >
                구분
              </th>
              <td>{v.category}</td>
            </tr>
            <tr>
              <th
                colSpan="5"
                className="sTdBgblue"
                style={{ verticalAlign: 'middle' }}
              >
                서비스 명
              </th>
              <td>{v.service_name}</td>
            </tr>
            <tr>
              <th
                colSpan="5"
                className="sTdBgblue"
                style={{ verticalAlign: 'middle' }}
              >
                시공지점 명
              </th>
              <td>{shopInfo.shop_name}</td>
            </tr>
            <tr>
              <th
                colSpan="5"
                className="sTdBgblue"
                style={{ verticalAlign: 'middle' }}
              >
                연락처
              </th>
              <td>{shopInfo.contact}</td>
            </tr>
            <tr>
              <th
                colSpan="5"
                className="sTdBgblue"
                style={{ verticalAlign: 'middle' }}
              >
                날짜
              </th>
              <td>{v.date}</td>
            </tr>
            <tr>
              <th
                colSpan="5"
                className="sTdBgblue"
                style={{ verticalAlign: 'middle' }}
              >
                금액
              </th>
              <td>{v.price}</td>
            </tr>
          </tbody>
        ))}
        <tbody>
          {false && (
            <tr>
              <td className="font-weight-bold sTdBgblue" colSpan="5">
                할인 금액
              </td>
              <td className="font-weight-bold" style={{ color: 'blue' }}>
                {discount}
              </td>
            </tr>
          )}
          <tr>
            <td className="font-weight-bold sTdBgblue" colSpan="5">
              서비스액 합계
            </td>
            <td className="font-weight-bold" style={{ color: 'red' }}>
              {`${totalPrice - discount}`}
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  );
};

export default ServiceList;
